export default {
    dashboard: 'Painel',
    ideas: 'Ideias',
    experiments: 'Experimentos',
    adAccounts: 'Contas de Anúncios',
    assessment: 'Minha Avaliação',
    profile: 'Perfil',
    logout: 'Sair',
};
